import { request } from './request';

export const fetchPearls = () => {
  return request('/pearls/user-organizations', 'GET');
};

export const submitPearl = (pearl) => {
  return request('/pearls', 'POST', { ...pearl });
};
